/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import "./src/assets/style/layout.css"
import "./src/assets/style/swiper.min.css"

import React from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

export const wrapRootElement = ({ element }) => (
  <GoogleReCaptchaProvider
    reCaptchaKey={
      process.env.GATSBY_RECAPTCHA_SITE_KEY ||
      "6LdFr8AqAAAAAKBOo9gX-oYJBf5GgG2G_VpNXUoQ"
    }
  >
    {element}
  </GoogleReCaptchaProvider>
)
